/* Dashboard.js */

"use strict";

module.exports = {
    name: "dashboard",
    label: "Dashboard",
    title: "My Dashboards",
    disabled: false,
    order: 1, // Deprecated -- Newer solution uses order from index.js
    app: "GameConsole",
    section: "Dashboard",
    license: ["GLUWARE"],
    accessPerm: ["dashboardAccess"],
    pageTitle: "Gluware Dashboard",
    helpLink: "Dashboards/Dashboard-overview.htm",
    iconName: "branding.deviceManager",
    navIcon: "dashboard.solution",
    navOptions: {
        running: {
            name: "Running Dashboard",
            options: {
                ra: "dashboard/view",
            },
            type: "exp",
        },
        library: {
            name: "Dashboard Library",
            options: {
                ra: "dashboard/library",
            },
            type: "exp",
        },
    },
};
